import React from 'react';

import { Modal } from '@opendoor/bricks/complex';

import NotificationPreferences from './NotificationPreferences';

interface INotificationPreferencesSectionProps {
  handleClose: () => void;
}
const NotificationPreferencesSection: React.FC<INotificationPreferencesSectionProps> = (
  props: INotificationPreferencesSectionProps,
) => {
  const { handleClose } = props;

  return (
    <Modal
      analyticsName="partnership-dashboard-fe-email-preferences-modal"
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      desktopAndTabletSize="lg"
      onRequestClose={handleClose}
      hasPadding={false}
      headerProps={{
        title: 'Email Preferences',
      }}
    >
      <NotificationPreferences withoutHeader />
    </Modal>
  );
};
export default NotificationPreferencesSection;
